import React, {useState, useRef} from 'react';
import { useTranslation } from 'react-i18next';
import { useForm, Controller } from 'react-hook-form';
import { 
    Box, 
    Button, 
    TextField, 
    Grid,
    InputAdornment,
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import { yupResolver } from '@hookform/resolvers/yup';
// import * as yup from 'yup';
import {useYupSchema} from '../../components/util/hookYupSchema'
import Modal from '@mui/material/Modal';
import { constants } from '../../util'
import { showWaiting } from '../../store/slices';
import { addAlbumSong } from '../../services/albumService';
import { enqueueSnackbar } from 'notistack';
import { useSelector, useDispatch } from 'react-redux';




const AddSong = ({albumId, open, onClose}) => {
    const lyricsRef = useRef(null);
    const audioRef = useRef(null);
    const dispatch = useDispatch();
    const {language, openSignup, deviceType} = useSelector(state => state.configuration);
    //TRANSLATION
    const [t, i18n] = useTranslation("global");


    const sch = (yup) => yup.object({
        nameSong: yup.string().required().min(3).max(40),
        lyricsFile: yup
            .mixed()
            .nullable()
            // .required(language==='es' ? 'El archivo de letra es requerido' : 'Lirycs file is required')
            .test('fileType', language==='es' ? 'Formato no soportado' : 'Not valid file type', (value) => {
                if (!value) return true; // Permitir si no hay archivo (la validación required ya lo maneja)
                return ['text/plain', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].includes(value.type);
            })
            .test('fileSize', language==='es' ? 'El archivo es muy grande, máximo permitido de 1MB' : 'Max filesize allowed is 1MB', (value) => {
                if (!value) return true;
                return value.size <= 1 * 1024 * 1024; // 1MB
            }),
        audioFile: yup
            .mixed()
            .required(language==='es' ? 'El archivo de audio es requerido' : 'Audio file is required')
            .test('fileSize', language==='es' ? 'El archivo es muy grande, máximo permitido de 100MB' : 'Max filesize allowed is 100MB', (value) => {
                if (!value) return true;
                return value.size <= 100 * 1024 * 1024; // 100MB
            })
            .test('fileType', language==='es' ? 'Solo se permiten archivos de audio WAV' : 'Not valid file type', (value) => {
                if (!value) return true;
                console.log('File type:', value.type);
                console.log('File name:', value.name);
                
                // Validar por tipo MIME
                const validMimeTypes = [
                    'audio/wav',
                    'audio/x-wav',
                    'audio/vnd.wave',
                    'audio/wave',
                    'audio/x-pn-wav'
                ];
                
                const isValidMime = validMimeTypes.includes(value.type.toLowerCase());
                
                // Validar por extensión
                const fileName = value.name || '';
                const isValidExtension = fileName.toLowerCase().endsWith('.wav');
                
                // Aceptar si cumple alguna de las dos
                return isValidMime || isValidExtension;
            })
    });
    const schema = useYupSchema(sch);


    const { control, register, handleSubmit, reset, setFocus, getValues, setValue, formState: { errors: errors } } = useForm({
            resolver: yupResolver(schema),
            defaultValues: {
                nameSong: '',
                lyricsFile: null,
                audioFile: null,
            }
        });
    

    const handleClose = () => {
        cleanForm();
        onClose(null);
    }

    const onSubmit = (data) => {
        dispatch(showWaiting(true));
        // const files = event.target.files;
        // if (lyricsFile !== null && audioFile != null){
            
            addAlbumSong(
                albumId.toString(),
                data.nameSong,
                data.lyricsFile,
                data.audioFile
            )
                .then((rsp)=>{
                    if (rsp.code === '00'){
                        dispatch(showWaiting(false));
                        onClose({
                            albumSongId: rsp.metadata?.albumSongId,
                            name: rsp.metadata?.name,
                            lyricsFile: rsp.metadata?.lyricsFile,
                            audioFile: rsp.metadata?.audioFile
                        });
                        
                        cleanForm();

                        enqueueSnackbar(
                            language === 'es'
                                ? 'Canción agregada con éxito'
                                : 'Song was added successfully'
                            , { variant: 'success', persist: false }
                        );
                    }
                    else{
                        dispatch(showWaiting(false));
                        enqueueSnackbar(rsp.message, { variant: 'error', persist: false });
                    }
                })
                .catch((error) => {
                    dispatch(showWaiting(false));
                    enqueueSnackbar(
                        language === 'es' 
                            ? 'Error al agregar la canción' 
                            : 'Error adding song',
                        { variant: 'error', persist: false }
                    );
                });
        // }
        // else{
        //     dispatch(showWaiting(false));
            
        //     if (lyricsFile===null || lyricsFile===undefined)
        //         enqueueSnackbar(
        //             language === 'es'
        //                 ? 'Archivo con letra de la canción es requerido'
        //                 : 'Lyrics file is needed'
        //             , { variant: 'error', persist: false }
        //         );

        //     if (audioFile===null || audioFile===undefined)
        //         enqueueSnackbar(
        //             language === 'es'
        //                 ? 'Archivo de audio es requerido'
        //                 : 'Audio file is needed'
        //             , { variant: 'error', persist: false }
        //         );
        // }
    }

    const cleanForm = () => {
        reset();

        // Limpiar manualmente los inputs file
        if (lyricsRef.current) lyricsRef.current.value = '';
        if (audioRef.current) audioRef.current.value = '';

        // Limpiar los estados de nombres de archivo
        setFileName('');
        setFileNameAudio('');
    }


    // const [lyricsFile, setLyricsFile] = useState(null);
    const [fileName, setFileName] = useState("");
    // const [eventLyricsFile, setEventLyricsFile] = useState(null);
    
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setValue('lyricsFile', file, { shouldValidate: true });
        setFileName(file?.name || '');
        if (!file) event.target.value = '';
    
    // const file = event.target.files[0];
    //     if (file) {
    //         setLyricsFile(file);
    //         setFileName(file.name);
    //         setEventLyricsFile(event);
    //     }
    //     else{
    //         setLyricsFile(null);
    //         setFileName(null);
    //         event.target.value = '';
    //     }
    };


    // const [audioFile, setAudioFile] = useState();
    const [fileNameAudio, setFileNameAudio] = useState("");
    // const [eventAudioFile, setEventAudioFile] = useState(null);

    const handleFileChangeAudio = (event) => {
        const file = event.target.files[0];
        setValue('audioFile', file, { shouldValidate: true });
        setFileNameAudio(file?.name || '');
        if (!file) event.target.value = '';

        // const file = event.target.files[0];
        // if (file) {
        //     setAudioFile(file);
        //     setFileNameAudio(file.name);
        //     setEventAudioFile(event);
        // }
        // else{
        //     setAudioFile(null);
        //     setFileNameAudio(null);
        //     event.target.value = '';
        // }
    };


    return(
        <>
            <Modal
                open={open}
                onClose={()=>handleClose()}
            >
                <Box component='form' onSubmit={handleSubmit(onSubmit)}
                    sx={{ ...constants.styles.modalBox, padding: '20px', width: '400px' }} 
                >
                    <Grid container spacing={3} direction="column" sx={{height: '100%'}}>
                        <b>{t("addAlbumGeneral.addSong")}</b>
                        <TextField id="txtName" label={t("signUp.name")} variant="outlined" margin="normal" autoFocus fullWidth sx={{...constants.styles.textfield, marginBottom: '0px'}} 
                            {...register('nameSong')}
                            error={!!errors.nameSong}
                            helperText={errors.nameSong?.message}
                        />
                        <div>
                            <TextField
                                label={t("addAlbumGeneral.lyrics")}
                                value={fileName}
                                error={!!errors.lyricsFile}
                                helperText={errors.lyricsFile?.message}
                                InputProps={{
                                    readOnly: true,
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <input
                                                type="file"
                                                ref={lyricsRef}
                                                id="file-input"
                                                style={{ display: 'none' }}
                                                onChange={handleFileChange}
                                                accept=".txt,.pdf,.doc,.docx"
                                            />
                                            <label htmlFor="file-input">
                                                <Button 
                                                    //   variant="contained" 
                                                    component="span"
                                                    //   component="label" 
                                                    variant="text" 
                                                    color="primary"
                                                    startIcon={<CloudUploadIcon />}
                                                    sx={{ ...constants.styles.linkButton, fontSize: '11px', position: 'relative' }}
                                                >
                                                    {t("addAlbumGeneral.btnBrowse")}
                                                </Button>
                                            </label>
                                        </InputAdornment>
                                    ),
                                }}
                                fullWidth
                            />
                            <div style={{fontSize:10,color:'gray',width:'100%',textAlign:'left',marginTop:'5px'}}>
                                {t("addAlbumGeneral.formatLyrics")}
                            </div>
                        </div>
                        <div>
                            <TextField
                                label={t("addAlbumGeneral.audio")}
                                value={fileNameAudio}
                                error={!!errors.audioFile}
                                helperText={errors.audioFile?.message}
                                InputProps={{
                                    readOnly: true,
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <input
                                                type="file"
                                                ref={audioRef}
                                                id="file-input-audio"
                                                style={{ display: 'none' }}
                                                onChange={handleFileChangeAudio}
                                                accept="audio/wav"
                                            />
                                            <label htmlFor="file-input-audio">
                                                <Button 
                                                    //   variant="contained" 
                                                    component="span"
                                                    //   component="label" 
                                                    variant="text" 
                                                    color="primary"
                                                    startIcon={<CloudUploadIcon />}
                                                    sx={{ ...constants.styles.linkButton, fontSize: '11px', position: 'relative' }}
                                                >
                                                    {t("addAlbumGeneral.btnBrowse")}
                                                </Button>
                                            </label>
                                        </InputAdornment>
                                    ),
                                }}
                                fullWidth
                            />
                            <div style={{fontSize:10,color:'gray',width:'100%',textAlign:'left',marginTop:'5px'}}>
                                {t("addAlbumGeneral.formatAudio")}
                            </div>
                        </div>

                        <div style={{display:'flex'}}>
                            <div style={{flex:1}}></div>
                            <Button
                                type="submit"
                                variant="outlined"
                                sx={{ ...constants.styles.mainButton, width: '49%', marginLeft:'10px' }}
                            >
                                {t("addAlbumGeneral.btnSave")}
                            </Button>
                            <Button
                                type="button"
                                variant="outlined"
                                onClick={()=>handleClose()}
                                sx={{ ...constants.styles.secondaryButton, width: '49%', marginLeft:'10px' }}
                            >
                                {t("addAlbumGeneral.btnCancel")}
                            </Button>
                        </div>
                    </Grid>
                </Box>
            </Modal>
        </>
    )
}

export default AddSong;